import { MultiValuedList } from '../../MultiValuedList'
import { TextMultiValuedListItem } from '../../TextMultiValuedList'
import { FlatMultiValuedListMoreItem } from '../FlatMultiValuedListMoreItem'

import { filterByChildren } from './FlatMultiValuedList.utils'

function FlatMultiValuedList({
  Item = TextMultiValuedListItem,
  MoreItem = FlatMultiValuedListMoreItem,
  filter = filterByChildren,
  ...restProps
}) {
  return (
    <MultiValuedList
      {...restProps}
      Item={Item}
      MoreItem={MoreItem}
      filter={filter}
    />
  )
}

export default FlatMultiValuedList
